<mat-card id="pharmacy-search">
    <app-matspinner *ngIf="isLoading"></app-matspinner>
    <mat-card-header>
      <mat-card-title class="title">Pharmacy Chain Search</mat-card-title>
    </mat-card-header>
    <mat-divider class="divider" style="margin-bottom: 0%;"></mat-divider>
    <br>
    <mat-card-content>
      <form>
  <div class="form-row-horizontal">
    <div class="form-group vendor-select-group">
      <mat-form-field class="ffs" appearance="outline">
        <mat-label>Select Vendor</mat-label>
        <mat-select
          id="vendor-select"
          (selectionChange)="OnVendorChange($event)"
          ngDefaultControl
        >
          <mat-option value="" disabled>Select Vendor</mat-option>
          <mat-option *ngFor="let vendor of vendorList" [value]="vendor.VendorId">{{vendor.VendorName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form-group search-group">
      <mat-form-field class="ffs" appearance="outline" style="font-size: 18px;">
        <input
          matInput
          id="pharmacy-search-input"
          type="text"
          [(ngModel)]="pharmacyFilter"
          name="pharmacyFilter"
          placeholder="Please enter Pharmacy Chain Name"
          (keyup.enter)="onSearchClick()"
          #input
          autocomplete="off"
        >
      </mat-form-field>
    </div>
    <!-- Search button -->
    <div class="search-button">
      <button
        mat-raised-button
        type="button"
        class="btn-save"
        (click)="onSearchClick()"
      >Search</button>
    </div>
    <!-- Export button -->
    <div class="export-button">
      <button
        mat-raised-button
        type="button"
        class="btn-save"
        (click)="ExportTOExcel()"
      >Export</button>
    </div>
  </div>











  
</form>
      <div class="mat-elevation-z8 table-container">
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="PharmacyID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Pharmacy Id </th>
            <td mat-cell *matCellDef="let row" class="table-row-font"> {{row.PharmacyID}} </td>
          </ng-container>
          <ng-container matColumnDef="PharmacyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Pharmacy Chain Name </th>
            <td mat-cell *matCellDef="let row" class="table-row-font"> {{row.PharmacyName}} </td>
          </ng-container>
          <ng-container matColumnDef="IsEnabled">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Pharmacy Chain Active </th>
            <td mat-cell *matCellDef="let row" class="table-row-font"> {{row.IsEnabled}} </td>
          </ng-container>
          <ng-container matColumnDef="EffectiveDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Activation Date </th>
            <td mat-cell *matCellDef="let row" class="table-row-font"> {{row.EffectiveDate}} </td>
          </ng-container>
          <ng-container matColumnDef="TermDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Deactivation Date </th>
            <td mat-cell *matCellDef="let row" class="table-row-font"> {{row.TermDate}} </td>
          </ng-container>
          <ng-container matColumnDef="PetEnabled">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Pet Trxn Enabled </th>
            <td mat-cell *matCellDef="let row" class="table-row-font"> {{row.PetEnabled}} </td>
          </ng-container>
          <ng-container matColumnDef="BillingGroup">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Billing Group </th>
            <td mat-cell *matCellDef="let row" class="table-row-font"> {{row.BillingGroup}} </td>
          </ng-container>
          <ng-container matColumnDef="BillingRegion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Billing Region </th>
            <td mat-cell *matCellDef="let row" class="table-row-font"> {{row.BillingRegion}} </td>
          </ng-container>
          <ng-container matColumnDef="Connectivity">
            <th mat-header-cell *matHeaderCellDef class="table-header-font">Connectivity</th>
            <td mat-cell *matCellDef="let row" class="table-row-font">
          
              <!-- ✅ Green check mark if connectivity is valid -->
              <ng-container *ngIf="getConnectivityStatus(row); else redIndicator">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <span style="color: green; font-weight: bold; font-size: 20px;">&#x2705;</span>
                </div>
              </ng-container>
          
              <!-- ❌ Red X with conditional navigation -->
              <ng-template #redIndicator>
                <ng-container *ngIf="!!row.IsVendorConnectionEnabled; else pharmacyLink">
                  <a [routerLink]="['/updatevendor', row.VendorId]" title="Edit Vendor" style="color: red; font-weight: bold; text-decoration: none;">
                    <div style="display: flex; align-items: center; justify-content: center;">
                      <span style="color: red; font-weight: bold; font-size: 20px;">&#x2716;</span>
                    </div>
                  </a>
                </ng-container>
                <ng-template #pharmacyLink>
                  <a [routerLink]="['/updatepharmacy', row.PharmacyID]" title="Edit Pharmacy Chain" style="color: red; font-weight: bold; text-decoration: none;">
                    <div style="display: flex; align-items: center; justify-content: center;">
                      <span style="color: red; font-weight: bold; font-size: 20px;">&#x2716;</span>
                    </div>
                  </a>
                </ng-template>
              </ng-template>
          
            </td>
          </ng-container>
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef class="table-header-font">Edit</th>
            <td mat-cell *matCellDef="let element" class="table-row-font">
              <button mat-icon-button color="primary" (click)="redirectToEdit(element.PharmacyID)">
                <mat-icon class="mat-18">edit</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: !isLoading?true:false"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No Pharmacies Found</td>
          </tr>
        </table>
       
        <mat-paginator [length]="length" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true" (page)="onPageEvent($event)"></mat-paginator>
        
      </div>
    </mat-card-content>
</mat-card>